import numberFormats from '@/configs/build/number-formats.json';

export default {
  fallbackLocale: 'en-us',
  numberFormats,
};
